import { useEffect, useState } from 'react';
import { AgentAttachedTrack } from '../components/agentChat/agentAttachedTrack';
import { searchCatalogTracks } from '../services/AgentTrackSearch.service';

export const useAgentTrackMentionSearch = (query: string | null) => {
  const [results, setResults] = useState<AgentAttachedTrack[]>([]);
  const [isSearching, setIsSearching] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    let cancelled = false;

    if (query == null) {
      setResults([]);
      setIsSearching(false);
      setActiveIndex(0);
      return () => {
        cancelled = true;
      };
    }

    const trimmed = query.trim();
    if (trimmed.length < 3) {
      setResults([]);
      setIsSearching(false);
      setActiveIndex(0);
      return () => {
        cancelled = true;
      };
    }

    setIsSearching(true);
    const timer = window.setTimeout(() => {
      void searchCatalogTracks(trimmed)
        .then((tracks) => {
          if (cancelled) return;
          setResults(tracks);
          setActiveIndex(0);
        })
        .catch(() => {
          if (cancelled) return;
          setResults([]);
        })
        .finally(() => {
          if (!cancelled) setIsSearching(false);
        });
    }, 400);

    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [query]);

  return { results, isSearching, activeIndex, setActiveIndex };
};
